import styled from 'styled-components'
import { Theme, Button } from '@pga/pga-component-library'

export const StyledForm = styled.form`
  display: flex;
  width: 100%;
  font-family: ${Theme.fonts.Montserrat};
  @media(min-width: 992px) {
    height: 65px;
  }
`

export const StyledSearchIconWrapper = styled.div`
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  position: absolute;
  padding: 10px;
  height: 100%;
`

export const StyledSearchClearWrapper = styled.div`
  display: flex;
  align-items: center;
  top: 0;
  right: 0;
  position: absolute;
  padding: 10px;
  height: 100%;
`

export const StyledInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 10px;
  width: ${props => props.fw ? '100%' : '440px'};
  height: 65px;
  max-height: 100%;
  font-size: 16px;
  border: 1px solid ${Theme.colors.blueGrey};
  background-color: ${Theme.colors.white};
  @media screen and (max-width: 991.98px) {
    margin-bottom: 10px;
    height: 51px;
    width: 100%;
  }
`
export const StyledLocationInputWrapper = styled(StyledInputWrapper)`
  width: ${props => props.fw ? '100%' : '320px'};
  & .algolia-places {
    width: 100%;
    height: 100%;
  }
  & .form-group {
    height: 100%;
    width: 100%;
    margin: 0;
  }
  @media screen and (max-width: 991.98px) {
    width: 100%;
  }
`

export const StyledInput = styled.input`
  height: 100%;
  width: 100%;
  font-size: 16px;
  border: none;
  outline: none;
  ::placeholder {
    color: ${Theme.colors.blueGrey};
    font-family: ${Theme.fonts.Montserrat};
    font-weight: 400;
  }
`

export const StyledInputSearch = styled(StyledInput)`
  padding-right: 26px;
  padding-left: 57px;
`

export const StyledButton = styled(Button)`
  width: 100%;
  min-width: 100%;
  height: 65px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  text-transform: none;
  @media screen and (max-width: 991.98px) {
    height: 51px;
  }
`
export const StyledButtonWrapper = styled.div`
  min-width: 140px;
`

export const MainWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media screen and (max-width: 991.98px) {
    flex-direction: column;
  }
`
